import { render, staticRenderFns } from "./ItemBox.vue?vue&type=template&id=107ff90e&scoped=true"
import script from "./ItemBox.vue?vue&type=script&lang=js"
export * from "./ItemBox.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "107ff90e",
  null
  
)

export default component.exports